import React from 'react'
import {
	Accordion,
	AccordionItem,
	AccordionPanel,
	AccordionButton,
	AccordionIcon,
	Flex,
	HStack,
	Icon,
	useColorModeValue,
} from '@chakra-ui/react'
import { FaFilter } from 'react-icons/fa'

export default function BggCollectionFiltersAccordion({ children }) {
	const panelBg = useColorModeValue('gray.50', 'bgg.900')
	const cardBorder = useColorModeValue('gray.200', 'whiteAlpha.300')

	return (
		<Accordion allowToggle reduceMotion>
			<AccordionItem border="none">
				<Flex justify="flex-end" w="100%">
					<AccordionButton
						px={2.5}
						py={2}
						rounded="lg"
						borderWidth="1px"
						borderColor={cardBorder}
						bg={panelBg}
						w="fit-content"
						minW="unset"
						flex="0 0 auto"
						_expanded={{ borderBottomRadius: 0, borderBottomWidth: 0 }}
						aria-label="Filters"
					>
						<HStack spacing={1.5}>
							<Icon as={FaFilter} boxSize={4} aria-hidden />
							<AccordionIcon />
						</HStack>
					</AccordionButton>
				</Flex>
				<AccordionPanel
					px={4}
					pb={5}
					pt={2}
					borderWidth="1px"
					borderTopWidth={0}
					borderColor={cardBorder}
					bg={panelBg}
					borderBottomRadius="lg"
				>
					{children}
				</AccordionPanel>
			</AccordionItem>
		</Accordion>
	)
}
